import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/system';

function PeerItemDetail({ physician_name, peerItem }) {
    const theme = useTheme();

    return (
        <Stack spacing={1.5} p={2} backgroundColor={theme.palette.background.white} borderRadius={1}>
            <Typography variant='bold'>Peer Card Comparison</Typography>
            <Typography variant='heavy' sx={{ fontSize: '14px' }}>Dr. {physician_name}</Typography>
            { peerItem ?
                <>
                    <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Open Quantity: </strong>{peerItem.open_quantity}</Typography>
                    <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Hold Quantity: </strong>{peerItem.hold_quantity}</Typography>
                </> :
                <Typography variant='normal' sx={{ fontSize: '14px', backgroundColor: theme.palette.background.categoryDrawer, p:0.5, borderRadius: 1 }}>Not On Card</Typography>
            }
        </Stack>
    );
}

export default PeerItemDetail;